export default __webpack_public_path__ + "static/media/qrok.9f206224.png";